"use client";

import { useAuthenticationModalStore } from '@/core/stores/auth';
import { useUserStore } from '@/core/stores/user';
import { useOutsideClick } from '@/hooks/useOutsideClick';
import { generateAvatar } from '@/utils/generateAvatar';
import { faMobileButton } from '@fortawesome/pro-regular-svg-icons';
import { faUser } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AnimatePresence, motion, useAnimate, useDragControls } from "framer-motion";
import Cookies from 'js-cookie';
import Image from "next/image";
import { usePathname, useRouter } from "next/navigation";
import { useEffect, useState } from "react";
import NextLink from './NextLink';
import Button from './ui/Button';
import HeaderSearch from './ui/HeaderSearch';
import Spinner from './ui/Spinner';
import ImageLoading from './ImageLoading';


const noHeadersPages = ['/map']

const Header = ({ }: { url?: string, currency?: string, baseApi?: string, hasUserToken?: boolean, clientToken?: string, wpAssetUrl?: string }) => {
  const wpAssetUrl = process.env.NEXT_PUBLIC_WP_ASSETS_BASE_URL
  const pathname = usePathname();
  const { setShowAuthModal } = useAuthenticationModalStore()
  const controls = useDragControls();
  const [scope, animate] = useAnimate();

  const [showMenu, setShowMenu] = useState(false)
  const [currency, setCurrency] = useState('USD')
  const [showCurrencies, setShowCurrencies] = useState(false)
  const router = useRouter()


  const { isGettingProfile, email, displayName, image, } = useUserStore()

  const ref = useOutsideClick(() => setShowCurrencies(false))


  useEffect(() => {
    setCurrency(Cookies.get('currency') || 'USD')
  }, [])

  const handleClick = (currency: string) => {
    Cookies.set('currency', currency);
    setCurrency(currency)
    router.refresh()
    window.location.reload()
  };



  const [showExploreModal, setShowExploreModal] = useState(false)
  const [showApp, setShowApp] = useState(false)

  const showAppRef = useOutsideClick(() => { setShowApp(false) })

  return pathname !== "/partnership/sign-in" && !pathname.includes('/map') && (
    <>
      <header className="z-[80] md:flex flex-col  text-gray-800 hidden fixed top-0 w-full left-0">
        <div className={`${(pathname === "/" || pathname === "/hotels") ? 'bg-white/50 backdrop-blur-md' :
          pathname === '/2024-black-friday' ? 'bg-neutral-800 text-white campaign' : 'bg-white/50 backdrop-blur-md'}
                         py-4 w-full relative z-10`}>
          <div className="z-10 my-container  mx-auto  relative   py-2 w-full flex-col items-start justify-between flex">
            <div className="flex w-full flex-row items-center justify-between ">
              <div className="flex flex-row min-w-fit items-center gap-3">
                <NextLink scroll={true} href={"/"}
                  className="font-semibold min-w-fit flex items-center gap-2">
                  <Image
                    className='rounded w-7 block object-cover'
                    width={300} height={300} alt='planingo logo'
                    src={`https://planingo.ai/wp-content/uploads/2024/12/logo-new-version-2.png`}
                  />
                  <span className='font-extrabold flex md:text-lg lg:text-xl'>Planin<span className='text-primary-600 block tracking-tighter font-extrabold'> Go</span></span>
                </NextLink>
                <HeaderSearch />
              </div>
              <div className='flex ml-16 flex-row gap-4 text-xs'>

                <NextLink className="hover:text-indigo-500 text-xs md:text-sm rounded-lg px-2 transition-colors duration-300" href={"/hotels"}>
                  Hotels
                </NextLink>
                {/* <NextLink
                  className="hover:text-indigo-500 text-xs md:text-sm rounded-lg px-2 transition-colors duration-300"
                  href={"/itineraries"}>
                  Itinerary Builder
                </NextLink> */}
                <NextLink
                  className="hover:text-indigo-500 text-xs md:text-sm rounded-lg px-2 transition-colors duration-300"
                  href={"/partnership"}>
                  Creators
                </NextLink>
                {!pathname.includes('/blog') && <NextLink className="hover:text-indigo-500 text-xs md:text-sm rounded-lg px-2 transition-colors duration-300"
                  href={"/blog"}>
                  Blogs
                </NextLink>}

                {/* <button onClick={() => setShowExploreModal(true)}
                  className='flex items-center group gap-2 text-xs md:text-sm  relative'>
                  <span>Explore More</span>
                  <FontAwesomeIcon icon={faChevronDown} />
                  <span className='peer  -translate-y-3  absolute left-0 z-10 top-0 w-full h-14'></span>
                  <div className={`${pathname === '/2024-black-friday' ? 'bg-neutral-800 shadow-indigo-800' : 'bg-white'} 
                  z-20 group-hover:opacity-100 h-0 group-hover:h-fit opacity-0 overflow-hidden group-hover:translate-y-2  transition-all duration-200 px-4 
                               shadow rounded absolute top-full right-0 min-w-[150px]`} >
                    <div>
                      <NextLink href={'/about-us'} className={`items-center border-b hover:text-indigo-500 transition-colors duration-300 py-3 justify-end gap-2  flex flex-row-reverse cursor-pointer `}>
                        <span className='text-sm peer min-w-max text-left'>
                          About us
                        </span>
                        <FontAwesomeIcon size='sm' className={`text-sm text-neutral-500 peer-hover:text-indigo-500 transition-colors duration-300`}
                          icon={faUsers} />
                      </NextLink>
                      {_id && <NextLink href={'/profile/refer'}
                        className={`items-center border-b hover:text-indigo-500 transition-colors duration-300 py-3 justify-end gap-2 flex flex-row-reverse cursor-pointer`}>
                        <span className='text-sm peer min-w-max text-left'>
                          Refer & Earn
                        </span>
                        <FontAwesomeIcon size='sm' className={`text-sm text-neutral-500 peer-hover:text-indigo-500 transition-colors duration-300`}
                          icon={faGift} />
                      </NextLink>}
                      <NextLink href={'/contact-us'} className={`items-center hover:text-indigo-500 transition-colors duration-300 py-3 justify-end gap-2 flex flex-row-reverse cursor-pointer`}>
                        <span className='text-sm  peer min-w-max text-left'>
                          Contact Us
                        </span>
                        <FontAwesomeIcon size='sm' className={`text-sm  text-neutral-500 peer-hover:text-indigo-500 transition-colors duration-300`}
                          icon={faMessages} />
                      </NextLink>
                    </div>
                  </div>

                </button> */}
              </div>
              <span className='grow'></span>
              <div className=" hidden md:flex flex-row items-center  text-sm font-medium text-gray-800">
                <div className='gap-3 flex items-center border-r '>
                  <div className='relative'>
                    <button onClick={() => setShowApp(s => !s)}
                      className={`${pathname === '/2024-black-friday' ? 'text-white' : 'text-neutral-700'} 
                        flex items-center gap-1 text-xs rounded-md px-1.5 py-0.5`}>
                      <FontAwesomeIcon icon={faMobileButton} />
                      <span> App</span>
                    </button>
                    <AnimatePresence>
                      {showApp && <motion.div
                        ref={showAppRef}
                        initial={{ opacity: 0 }}
                        exit={{ opacity: 0 }}
                        animate={{ opacity: 100 }}
                        className={`
                             absolute top-full -translate-x-1/2 translate-y-1.5 transition-all border-indigo-100 border duration-300 left-1/2
                          min-w-max w-[200px] bg-white p-1.5 rounded-md shadow items-center gap-2`}>
                        <div className='flex flex-col justify-center items-center'>
                          <Image className='rounded w-7' width={300} height={300} alt='planingo'
                            src={`https://planingo.ai/wp-content/uploads/2024/12/logo-new-version-2.png`} />
                          <p className='text-sm text-neutral-700 font-semibold my-4'>Get the PlaninGo App</p>
                          <div className='flex flex-col gap-1 items-center'>
                            <Image className='w-20' width={300} height={150} alt='App Store'
                              src={`${process.env.NEXT_PUBLIC_STORAGE_URL}assets/c9e0fb25-84bd-4345-99dd-814624c79c19-planingo.png`} />
                            <span className='text-xs text-neutral-600'> Scan to get the app</span>
                          </div>
                          <div className='mt-4 flex items-center justify-center gap-2'>
                            <NextLink className='' href={'https://apps.apple.com/tr/app/planingo/id6504288085'}>
                              <Image className='w-24' width={300} height={150} alt='App Store'
                                src={`${process.env.NEXT_PUBLIC_STORAGE_URL}assets/34fbb833-49ae-4fea-b2d3-5c4a2c039ebd.png`} />
                            </NextLink>
                            <NextLink className='' href={'https://play.google.com/store/apps/details?id=ai.planingo'}>
                              <Image className='w-24' width={300} height={150} alt='google Store'
                                src={`${process.env.NEXT_PUBLIC_STORAGE_URL}assets/0fe7f354-9653-47f5-bffb-3bd8a3039916.png`} />
                            </NextLink>
                          </div>
                        </div>

                      </motion.div>}
                    </AnimatePresence>
                  </div>

                  {/* <div className='relative border-r border-indigo-500 pr-3'>
                    <button onClick={() => setShowCurrencies(s => !s)}
                      className={`text-indigo-500 text-xs rounded-md px-1.5 py-0.5`}
                    >
                      <span className='pe-1'>{currencies[currency!]}</span>
                      {currency}
                    </button>
                    <AnimatePresence>
                      {showCurrencies && <motion.div
                        ref={ref}
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 100 }}
                        exit={{ opacity: 0 }}
                        className='p-4 bg-white min-w-[500px] translate-y-2 shadow rounded absolute top-full right-0'
                      >
                        <p className='text-sm text-neutral-700 font-bold pb-4 border-b min-w-max'>
                          Select Your Currency</p>
                        <div className='grid grid-cols-2'>
                          <div onClick={(e) => {
                            e.stopPropagation()
                            handleClick('EUR')
                          }} className={`${currency === 'EUR' ? 'text-indigo-500' : 'text-neutral-700'}
  items-center pl-2 py-3 grid gap-2 grid-cols-[1fr,_auto] cursor-pointer `}>
                            <span>EUR - Euro</span>
                          </div>
                          <div onClick={(e) => {
                            e.stopPropagation()
                            handleClick('USD')
                          }} className={`${currency === 'USD' ? 'text-indigo-500' : 'text-neutral-700'}
    items-center pl-2 py-3 grid gap-2 grid-cols-[1fr,_auto] cursor-pointer `}>
                            <span>USD - United States Dollar ($)</span>
                          </div>
                          <div onClick={(e) => {
                            e.stopPropagation()
                            handleClick('GBP')
                          }} className={`${currency === 'GBP' ? 'text-indigo-500' : 'text-neutral-700'}
    items-center pl-2 py-3 grid gap-2 grid-cols-[1fr,_auto] cursor-pointer `}>
                            <span>GBP - British Pound</span>
                          </div>

                        </div>
                      </motion.div>}

                    </AnimatePresence>
                  </div> */}
                </div>
                <AnimatePresence >
                  {(email) ?
                    <motion.div
                      initial={{ opacity: 0, y: 1 }}
                      exit={{ opacity: 0, y: 1 }}
                      animate={{ opacity: 100, y: 0 }}
                      transition={{ damping: 15 }}
                      className="relative pl-2.5">
                      <NextLink href={'/profile'} className=" z-50 grid grid-cols-[36px,_1fr] gap-2 items-center">
                        <span className='size-9 p-0.5 rounded-full'>
                          {
                            (image || email) &&
                            <ImageLoading width={100} height={100} src={image || generateAvatar(email)}
                              className="object-cover w-full h-full rounded-full border border-indigo-500" alt="Planingo" />
                          }
                        </span>
                        <div className='hidden lg:flex flex-col justify-between '>
                          <span className={`${pathname === '/2024-black-friday' ? 'text-white' : 'text-neutral-700'} text-sm`}>{displayName}</span>
                          <span className={`${pathname === '/2024-black-friday' ? 'text-white' : 'text-neutral-700'} text-[10px]`}>
                            {email}
                          </span>
                        </div>
                      </NextLink>

                    </motion.div> : isGettingProfile ? <div className=' w-full flex justify-center pl-4'> <Spinner />
                    </div> :
                      <Button size='small' radius='rounded-xl' color='secondary' className='ml-4' onClick={() => setShowAuthModal(true)}>
                        <FontAwesomeIcon icon={faUser} />
                        Sign in
                      </Button>
                  }
                </AnimatePresence>
              </div>
            </div>
          </div>
        </div>
        {/* <IntroBanner /> */}
      </header >
      <div className={`hidden md:block ${(pathname === "/search") ? 'h-10 mb-1' : pathname === "/" ? 'h-0 hidden' : 'h-16 sm:h-20 lg:h-16 mb-1'}`}></div>
    </>
  );
};

export default Header;
